<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.2556 0.976324L10.2556 7.7439L17.0232 7.7439C17.3315
    7.7439 18 8.16253 18 8.99976C18 9.83699 17.3315 10.2556 17.0232
    10.2556L10.2556 10.2556L10.2556 17.0232C10.2556 17.3315 9.83698
    18 8.99979 18C8.1626 18 7.74393 17.3315 7.74393 17.0232L7.74393
    10.2556L0.976285 10.2556C0.668066 10.2556 -0.000486632 9.83699
    -0.000486669 8.99972C-0.000486705 8.16246 0.668066 7.74386 0.976285
    7.74386L7.74393 7.74386L7.74393 0.976214C7.74393 0.667995 8.16253
    -0.000556608 8.99979 -0.000556645C9.83706 -0.000556682 10.2556
    0.668069 10.2556 0.976324Z" fill="#0D7BC4"/>
  </svg>
</template>

<script>
export default {
  name: 'Plus'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/Icons/Plus.vue